// opportunity close lost reasons
export enum CloseLostReason {
  AnyStar = '*',
  Price = 'price',
  NoBudget = 'no-budget',
  LostToCompetitor = 'lost-to-competitor',
  NotReady = 'not-ready',
  Other = 'other',
}

export function I18NKey(reason: CloseLostReason | string): string {
  switch (reason) {
    case CloseLostReason.AnyStar:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.ANY';
    case CloseLostReason.Price:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.PRICE';
    case CloseLostReason.NoBudget:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.NO_BUDGET';
    case CloseLostReason.LostToCompetitor:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.LOST_TO_COMPETITOR';
    case CloseLostReason.NotReady:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.NOT_READY';
    case CloseLostReason.Other:
      return 'AUTOMATIONS.EDITOR.TRIGGERS.OPPORTUNITY.CLOSED_LOST_REASON_OPTIONS.OTHER';
    default:
      return '';
  }
}
